import {httpRequest} from "@/providers/http";
import {adaptGames} from "./games.adapter";
import type {Game, GamesApiResponse} from "./games.types";

export interface GetGamesParams {
  provider?: string;
}

export const getNewestGamesService = async (params: GetGamesParams = {}): Promise<Game[]> => {
  const response = await httpRequest<GamesApiResponse>({
    method: "GET",
    url: "/public/games/newest",
    query: params.provider ? {provider: params.provider} : undefined,
    auth: false,
  });
  return adaptGames(response);
};
